<template>
  <div
    v-if="isLoading"
    class="loader"
  />
  <div
    v-else
    class="contract_form">
    <p>
      申し込み受付後、以降の契約の詳細な流れをメールにてご連絡いたします。
    </p>
    <ul>
      <li>
        <button
          class="btn mb15"
          @click="addContract">はい</button>
      </li>
      <li>
        <button
          class="btn btn-wt"
          @click="$emit('close')">いいえ</button>
      </li>
    </ul>
  </div>
</template>
<script>
  import OrganizationApi from '../../../api/organizations.js'

  export default {
    props: {
      organization: {
        type: Object,
        requires: true,
        default: null
      },
    },
    data () {
      return {
        isLoading: false
      }
    },
    methods: {
      addContract() {
        this.isLoading = true
        OrganizationApi.addContract(this.organization.id).then(() => {
          // TODO: 取り急ぎ、、、
          location.reload()
        })
      }
    }
  }
</script>
<style scoped>
  .contract_form li {
    padding: 20px 0;
    height: auto !important;
  }
</style>
